import { Injectable } from '@angular/core';
import { KeyValAdminService } from './key-val-admin.service';

@Injectable({
  providedIn: 'root'
})
export class AvatarImageService {
  private botAvatarUrl: string = '';
  private userAvatarUrl: string = '';

  constructor(
    protected keyvalService: KeyValAdminService
  ) { }

  public async loadAvatarUrls() {
    await this.loadBotAvatarUrl();
    await this.loadUserAvatarUrl();
  }

  public async loadBotAvatarUrl() {
    this.botAvatarUrl = await this.keyvalService.getKeyValEntry('botAvatar', 'avatarImage') as string | undefined ?? '';

  }

  public async loadUserAvatarUrl() {
    this.userAvatarUrl = await this.keyvalService.getKeyValEntry('userAvatar', 'avatarImage') as string | undefined ?? '';
  }

  public getBotAvatar() {
    return this.botAvatarUrl;
  }

  public getUserAvatar() {
    return this.userAvatarUrl;
  }
}
